import React, { useEffect, useState, useRef } from "react";
import { Text, View, Pressable, Linking } from "react-native";
import WebView from "react-native-webview";
import { useDispatch } from "react-redux";
import { SHOW_CALENDAR_ENTRY_MODAL } from "@reduxLocal/actions/types";
import { navigationRef } from "@navigation/rootNavigation";
import styles from "@stylesheet";
import { FontAwesome, FontAwesome5, Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import apis from "@api/api";
import { Buffer } from 'buffer';
import { useNavigation } from "@react-navigation/native";

const IndividualMailScreen = ({ route }) => {
  const { selectedMail, accessToken } = route.params;
  const [plusRotated, setPlusRotated] = useState(false);
  const [rotation, setRotation] = useState(0);
  const mailWebView = useRef<WebView>(null);
  const navigation = useNavigation();
  useEffect(() => {
    handleMarkMail();
  }, []);

    const handleMarkMail = async () => {
      try {
        await apis.markRead(selectedMail?.id, accessToken);
      } catch (error) {
        console.error('Error marking item read', error);
      }
    };

    const spinLeft = () => {
      setRotation(45);
      setPlusRotated(true);
    };

    const spinRight = () => {
      setRotation(0);
      setPlusRotated(false);
    };

    const from = () => selectedMail?.payload.headers.find(header => header.name === 'From')?.value || '';

    const subject = () => selectedMail?.payload.headers.find(header => header.name === 'Subject')?.value || '';

    const body = () => {
      if (selectedMail) {
        const partMail = selectedMail.payload.parts?.find(parts => parts.mimeType === 'text/html');
        if (partMail) {
          return Buffer.from(partMail.body.data, 'base64').toString();
        } else {
          return Buffer.from(selectedMail.payload.body.data, 'base64').toString();
        }
      }
      return '';
    };

    return (
      <View style={{ flex: 1, paddingTop: 8 }}>
        <View style={{ alignSelf: 'stretch' }}>
          {plusRotated && (
            <Animatable.View useNativeDriver animation={'fadeInRight'} duration={200} easing={'ease-in-expo'} direction={plusRotated ? 'normal' : 'reverse'} style={{ position: 'absolute', flexDirection: 'row', backgroundColor: 'white', bottom: 30, right: 60, minHeight: 50, borderTopLeftRadius: 30, borderBottomLeftRadius: 30, minWidth: 200, borderWidth: 1, borderColor: 'rgb(90,192,234)' }}>
              <Pressable style={{ flex: 1, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }} onPress={() => dispatch({ type: SHOW_CALENDAR_ENTRY_MODAL })}>
                <FontAwesome name="calendar-plus-o" size={24} color="black" />
                <Text adjustsFontSizeToFit style={{ fontSize: 10 }} selectable={false}>Add Entry</Text>
              </Pressable>
              <Pressable style={{ flex: 1, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                <MaterialCommunityIcons name="calendar-star" size={26} color="black" />
                <Text adjustsFontSizeToFit style={{ fontSize: 10 }} selectable={false}>List Starred</Text>
              </Pressable>
            </Animatable.View>
          )}
          <View style={{ flexDirection: 'row', bottom: 100, right: 100, position: 'absolute', backgroundColor: 'rgb(90,192,234)', borderRadius: 100, minWidth: 50, minHeight: 50, alignContent: "center", alignItems: 'center', justifyContent: 'center', transform: [{ rotateZ: `${rotation}deg` }] }}>
            <Pressable onPress={() => plusRotated ? spinRight() : spinLeft()}>
              <FontAwesome5 name="plus" size={24} color="white" />
            </Pressable>
          </View>
          <View style={{ backgroundColor: 'white', flexDirection: 'row', padding: 5, paddingLeft: 0, flex: 1, elevation: 1, shadowRadius: 5, shadowOpacity: 0.4, zIndex: 2, alignSelf: 'stretch', minHeight: 100 }}>
            <Pressable
              onPress={() => navigation.goBack()}
              style={[styles.BackToLogin, { minWidth: 10, flexDirection: 'row', flex: .5, justifyContent: 'space-evenly', borderRadius: 40 }]}
            >
              <Ionicons name="arrow-back-outline" size={20} color={'white'} />
            </Pressable>
            <View style={{ flexDirection: 'column', flex: 10 }}>
              <View style={{ flex: 1 }}>
                <Text adjustsFontSizeToFit style={{ marginHorizontal: 5, fontWeight: '600' }}>From</Text>
                <Text adjustsFontSizeToFit >{from()}</Text>
              </View>
              <View style={{ flex: 2 }}>
                <Text adjustsFontSizeToFit style={{ marginHorizontal: 5, fontWeight: '600' }}>Subject</Text>
                <Text adjustsFontSizeToFit >{subject()}</Text>
              </View>
            </View>
          </View>
          <View style={{ flex: 30, paddingBottom: "20%", marginBottom: "20%", borderRadius: 20, minHeight: '90%' }}>
            <WebView
              ref={mailWebView}
              onNavigationStateChange={(event) => {
                if (event.url.includes('http://') || event.url.includes('https://')) {
                  mailWebView.current?.stopLoading();
                  Linking.openURL(event.url);
                }
              }}
              originWhitelist={['*']} source={{ html: body() }} style={{ alignSelf: 'stretch', height: 800, marginBottom: 30, paddingBottom: 50 }} />
          </View>
        </View>
      </View>
    );
  };

export default IndividualMailScreen;
